import { buttonType } from '@sgui-plus/components/button'
import { Question } from '@sgui-plus/icons-vue'
import { buildProps, definePropType } from '@sgui-plus/utils/props'

import type { Component, ExtractPropTypes } from 'vue'

export const popconfirmProps = buildProps({
  title: {
    type: String,
  },
  confirmButtonText: {
    type: String,
  },
  cancelButtonText: {
    type: String,
  },
  confirmButtonType: {
    type: String,
    values: buttonType,
    default: 'primary',
  },
  cancelButtonType: {
    type: String,
    values: buttonType,
    default: 'text',
  },
  icon: {
    type: definePropType<string | Component>([String, Object]),
    default: Question as any,
  },
  iconColor: {
    type: String,
    default: '#f90',
  },
  hideIcon: {
    type: Boolean,
    default: false,
  },
  hideAfter: {
    type: Number,
    default: 200,
  },
  onConfirm: {
    type: definePropType<(e: Event) => Promise<boolean> | boolean>(Function),
  },
  onCancel: {
    type: definePropType<(e: Event) => Promise<boolean> | boolean>(Function),
  },
  transfer: {
    type: Boolean,
    default: true,
  },
  width: {
    type: [String, Number],
    default: 150,
  },
} as const)
export type PopconfirmProps = ExtractPropTypes<typeof popconfirmProps>
